/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Error_TypeInputs */

const vi_media_error_type = /** @type {(inputs: Media_Error_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chỉ nhận ảnh JPG, PNG, WebP hoặc video MP4.`)
};

/**

* @param {Media_Error_TypeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_error_type = /** @type {((inputs?: Media_Error_TypeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Error_TypeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_error_type(inputs)
});